const API_DJXY_URL = 'https://api.djxy.de/api';

export const MaxiDingConfig = {
    loginUrl: 'https://auth.djxy.de/auth/login',
    getMaxiDailyCheckInUrl: API_DJXY_URL + '/maxi/daily/',
    addMaxiDailyCheckInUrl: API_DJXY_URL + '/maxi/daily',
    getMaxiAvailableCheckInItemUrl: API_DJXY_URL + '/maxi/checkin/available',
    dailyCheckInUrl: API_DJXY_URL + '/maxi/daily',
    messageUrl: API_DJXY_URL + '/maxi/msg',
    getAge: API_DJXY_URL + '/maxi/age',
    learnCharacter: API_DJXY_URL + '/maxi/learn/char',
}

export const LEARN_CHARACTER_TYPE = {
    CHINESE: 'CHINESE',
    ALPHABET_DE: 'ALPHABET_DE',
    NUMBER: 'NUMBER',
}